export const showModal = type => ({
  type: 'show_modal',
  payload: type
});

export const hideModal = () => ({
  type: 'hide_modal'
});

export const makeFull = (type) => ({
  type: 'make_full',
  payload: type
});
